module.exports = __webpack_public_path__ + "81af4e7928c1b28e02c1bfbd82d3754a.png";